import { createAction, props } from '@ngrx/store';

import { User } from '@domain/types';
import * as ActionTypes from './user.actionTypes';

export const loadUser = createAction(ActionTypes.LOAD_USER, props<{ user: User }>());
